import React from 'react';
import cx from 'classnames';
import useBuildVariantProps from '../../../modules/theme/useBuildVariantProps';

import styles from './Spinner.module.scss';
import { SpinnerProps } from './Spinner.types';

const Spinner = ({ className, 'component-variant': componentVariant }: SpinnerProps) => {
  const variantProps = useBuildVariantProps(
    'spinner',
    {},
    undefined,
    componentVariant,
  );

  return (
    <div 
      role="alert" 
      aria-atomic="true" 
      className={cx(styles.spinner, className)}
      {...variantProps}
    >
      <div className={styles.inner} />
    </div>
  );
};

export default Spinner;
